<template>
    <div class="pt-24">
        <div class="bg-main-black">
            <div class="w-full text-center pt-8 opacity-25">
                <a href="#" v-scroll-to="'#app'"><img src="./../assets/up-arrow.svg" alt="" class="h-6"></a>
            </div>
            <div class="font-serif antialiased  bg-main-black text-grey-lightest text-center font-semibold text-3xl mt-6">
                <div class="flex justify-center items-center w-full text-center">
                    <div>
                        <img src="./../assets/logo.svg" alt="Luyao Logo" class="h-16 rounded mr-6" />
                    </div>
                    <a href="/" class="no-underline text-white">Luyao</a>
                </div>
            </div>
            <div class="flex items-start justify-center text-center text-grey-lightest mt-24">
                <div class="md:w-1/5 xs:w-1/3">
                    <div class="font-bold text-lg">Features</div>
                    <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4" v-scroll-to="'#features'">
                        <a href="#" class="no-underline text-grey-lightest">Health record</a>
                    </div>

                </div>
                <div class="md:w-1/5 xs:w-1/3">
                    <div class="font-bold text-lg">Downloads</div>
                    <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4" v-scroll-to="'#download'">
                        <a href="#" class="no-underline text-grey-lightest">Apple App Store <span
                                class="md:inline-block xs:hidden">(iOS)</span></a>
                        <a href="#" class="no-underline text-grey-lightest mt-2">Google Play Store <span
                                class="md:inline-block xs:hidden">(Android)</span></a>
                    </div>

                </div>
                <div class="md:w-1/5 xs:w-1/3">
                    <div class="font-bold text-lg">Company</div>
                    <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4">
                        <a href="/#/terms" class="no-underline text-grey-lightest">Terms & Conditions</a>
                    </div>
                    <div class="flex flex-col items-center font-thin text-sm opacity-50 mt-4">
                        <a href="/#/privacy" class="no-underline text-grey-lightest">Privacy Policy</a>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap mt-12 mx-12 items-center justify-between p-3 ">
                <div class="text-grey-lightest text-sm opacity-75">
                    designed and developed by
                    <a href="https://github.com/siokas" class="no-underline text-blue">siokas</a>
                </div>
                <!-- <a class="text-white text-sm" href="https://beian.miit.gov.cn" target="_blank">
                    辽ICP备2023013427号-1
                </a> -->
            </div>

        </div>
    </div>
</template>

<script>
export default {

};
</script>